module.exports = ".user-profile .user-pic img {\n    margin-top:50px;\n    width:73px;    \n    height: 69px\n}"